import React from 'react';
import CardContent from "@mui/joy/CardContent";
import Card from "@mui/joy/Card";
import {CircularProgress, Stack} from "@mui/joy";
import Chip from "@mui/joy/Chip";

// components
import CommonEditModal from "../Common/CommonEditModal";
import CommonCallBackButton from "../Common/CommonCallBackButton";
import BaseApi from "../../utils/BaseApi";
import CallsListModal from "../Communication/CallsListModal";

// icons
import DeleteIcon from "@mui/icons-material/Delete";


class CommunicationCard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            communication: null,
        };
    }

    async componentDidMount() {
        if (this.props.communication.type === 'phone' && (!this.props.communication.standard_content || this.props.communication.standard_content === '')){
            await this.retrieveStandardContent()
        }
        else {
            this.setState(
            {
                communication: this.props.communication
            }
        );
        }
    }

    async retrieveStandardContent() {
        const url = `communication/${this.props.communication.id}/standard_content/`;
        const api = new BaseApi();
        let response = await api.get(
            url,
            {}
        );
        this.setState(
            {
                communication: response.data
            }
        );
    }

    async destroy() {
        const url = `communication/${this.props.communication.id}/`;
        const api = new BaseApi();
        await api.delete(url, {});
        await this.props.callBack();
    }

    render() {
        if (!this.state.communication){
            return (<CircularProgress/>)
        }
        return(
            <Card
                variant={'outlined'}
                size={'sm'}
            >
                <CardContent>
                    <Stack
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="center"
                        spacing={2}
                    >
                        <Chip
                            size={'sm'}
                            color={'primary'}
                        >
                            {this.state.communication.type_human}
                        </Chip>
                        <Chip
                            size={'sm'}
                            color={'primary'}
                        >
                            {this.state.communication.subtype_human}
                        </Chip>
                        <Chip
                            size={'sm'}
                            color={'neutral'}
                        >
                            {this.state.communication.content}
                            {
                                this.state.communication.extra_content? `; ${this.state.communication.extra_content}`:null
                            }
                        </Chip>
                        {
                            (this.state.communication.type === 'phone' && this.props.permissions?.callPermission && this.props.showCalls)?
                                <CallsListModal
                                    phone={this.state.communication.standard_content}
                                    flat={true}
                                />:
                                null
                        }
                        {
                            this.props.permissions?.destroyPermission?
                                <CommonCallBackButton
                                    flat={true}
                                    callBack={this.destroy.bind(this)}
                                    icon={DeleteIcon}
                                />:
                                null
                        }
                        {
                            this.props.permissions?.updatePermission ?
                                <CommonEditModal
                                    flat={true}
                                    fields={
                                        [
                                            'type',
                                            'subtype',
                                            'content',
                                            'extra_content',
                                        ]
                                    }
                                    baseUrl={'communication'}
                                    obj={this.state.communication}
                                    callBack={this.props.callBack}
                                /> :
                                null
                        }
                    </Stack>
                </CardContent>
            </Card>
        )
    }
}

export default CommunicationCard